<template>
    <div class="m-gift">
        <div class="m-banner">
            <img src="../../assets/images/gift/banner.jpg" alt="">
        </div> 
        <div class="city-list">
            <a v-for="(item,index) in nav" :key="index" :href="`#/gxnews/more/`+item.sortid" :class="item.class">{{item.name}}</a>
        </div> 
        <div class="m-slider">
            <van-swipe :autoplay="3000">
                <van-swipe-item v-for="(sw,index) in swipers" :key="index">
                    <div class="list">
                        <a :href="sw.url">
                            <img :src="sw.img" width="100%"/>
                            <span>{{sw.title}}</span>
                        </a>
                    </div>
                </van-swipe-item>
            </van-swipe>
        </div> 
        <div class="news-list-up">
            <ul>
                <li  v-for="(tp,index) in topics" :key="index">
                    <a :href="tp.url">
                        <div class="title">{{tp.title}}</div>
                        <div class="from">{{tp.humantime}}</div>
                    </a>
                </li>
            </ul>
            <div class="more">
                <router-link to="/gxnews/more/51185">更多</router-link>
            </div>    
        </div>
        <div class="m-ad">
            <ul>
                <li>
                    <a href="">
                        <img src="../../assets/images/gift/ad_1.jpg" alt="">
                    </a>
                </li>
                <li>
                    <a href="">
                        <img src="../../assets/images/gift/pic_2.jpg" alt="">
                    </a>
                </li>
                <li>
                    <router-link to="/gxnews/more/51187">
                        <img src="../../assets/images/gift/pic_3.jpg" alt="">
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="m-video" v-for="(video,index) in videos" :key="index">
            
            <a :href="video.url"><div class="v-box">
                <img :src="video.img" width="100%"/>
            </div>
            <div class="title">{{video.title}}</div></a>
        </div>
        <div class="m-ad">
            <a href="">
                <img src="../../assets/images/gift/ad_2.jpg" alt="">
            </a>    
        </div> 
        <div class="news-list-down">
            <ul>
                <li v-for="(yiqi,index) in yiqifupin" :key="index">
                    <a :href="yiqi.url">
                        <div class="pic">
                            <img :src="yiqi.img" alt="">    
                        </div>
                        <div class="title">{{yiqi.title}}</div>
                    </a>
                </li>
            </ul>
            <div class="more">
                <router-link to="/gxnews/more/51187">更多</router-link>
            </div>    
        </div>
        <div class="m-localtion">
            <div class="map">
                <img src="../../assets/images/gift/map.jpg" alt="">
            </div>
            <div class="phone">
                <div class="box">
                    <i></i>
                    联系我们
                </div>
            </div>
        </div>
        <div class="m-footer">
            <p>地址：广西南宁市民主路21号 邮编：530026</p>
            <p>电话：（0771）5690531（办）</p>
            <p>传真：（0771）5690897</p>
        </div> 
    </div>
</template>

<script>
    import 'vant/lib/index.css'
    import jsonp from 'jsonp';

    export default {
        data(){
            return{
                nav:[
                    {name: '南宁', class: 'nn', sortid:"51242"},
                    {name: '柳州', class: 'lz', sortid:"51243"},
                    {name: '桂林', class: 'gl', sortid:"51244"},
                    {name: '梧州', class: 'wz', sortid:"51245"},
                    {name: '北海', class: 'bh', sortid:"51249"},
                    {name: '崇左', class: 'cz', sortid:"51251"},
                    {name: '来宾', class: 'lb', sortid:"51254"},
                    {name: '贺州', class: 'hz', sortid:"51255"},
                    {name: '玉林', class: 'yl', sortid:"51246"},
                    {name: '百色', class: 'bs', sortid:"51253"},
                    {name: '钦州', class: 'qz', sortid:"51250"},
                    {name: '防城港', class: 'fcg', sortid:"51247"},
                    {name: '贵港', class: 'gg', sortid:"51248"},
                    {name: '河池', class: 'hc', sortid:"51252"}
                ],
                swipers:[],
                topics:[],
                videos:[],
                yiqifupin:[],

            }
        },
        mounted () {
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51184&start=0&limit=6', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("swipers",data);
                    this.swipers = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51185&start=0&limit=6', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("topics",data);
                    this.topics = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51188&start=0&limit=1', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("videos",data);
                    this.videos = data;
                }
            })

            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51187&start=0&limit=4', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("yiqifupin",data);
                    this.yiqifupin = data;
                }
            })


        },
    }
</script>

<style lang="less" scoped>
    .m-banner{
        img{
            width: 100%;
        }
    }
    .city-list{
        padding: 0.6rem 0.2rem 0.3rem 0.2rem;
        overflow: hidden;
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        flex-wrap: wrap;
        a{
            width: 1.5rem;
            height: 1rem;
            border-radius: 0.2rem;
            float: left;
            line-height: 1rem;
            text-align: center;
            color: #fff;
            font-size: 0.43rem;
            margin: 0 0.2rem 0.3rem 0.22rem;
            text-shadow: 0 0.05rem 0.08rem #666;
        }
        .nn{
            background: #f5827b;
        }
        .lz{
            background: #6ae0a2;
        }
        .gl{
            background: #f6c769;
        }
        .wz{
            background: #f2a35d;
        }
        .bh{
            background: #949af7;
        }
        .cz{
            background: #6faaee;
        }
        .lb{
            background: #6cd7ce;
        }
        .hz{
            background: #eb7998;
        }
        .yl{
            background: #6ae0a2;
        }
        .bs{
            background: #f6837c;
        }
        .qz{
            background: #f6837c;
        }
        .fcg{
            background: #949bf7;
        }
        .gg{
            background: #f5c667;
        }
        .hc{
            background: #6ea9ed;
        }
    }
    .m-slider{
        padding: 0 0.3rem;
        .list{
            position: relative;
            img{
                width: 100%;
                border-radius: 0.2rem;
            }
            span{
                display: block;
                position: absolute;
                width: 100%;
                padding: 0.15rem 0.3rem;
                background: rgba(0,0,0,0.4);
                color: #fff;
                font-size: 0.4rem;
                left: 0;
                bottom: 0;
                box-sizing: border-box;
                border-bottom-left-radius: 0.2rem;
                border-bottom-right-radius: 0.2rem;
            }
        }
    }
    .news-list-up{
        margin-top: 0.5rem;
        li{
            padding: 0 0.3rem 0.2rem 0.3rem;
            border-bottom: 1px solid #e2e2e2;
            margin-top: 0.25rem;
            &:nth-last-of-type(1){
                border-bottom: none;
            }
            .title{
                font-size: 0.42rem;
                color: #333;
            }
            .from{
                font-size: 0.32rem;
                color: #7f8080;   
                margin-top: 0.15rem; 
            }
        }
        .more{
            margin-top: 0.3rem;
            padding: 0 1.5rem;
            a{
                display: block;
                padding: 0.2rem 0.5rem;
                color: #fff;
                font-size: 0.4rem;
                border-radius: 0.5rem;
                background: #3f6648;
                text-align: center;
                font-weight: bold;
            }
        }
    }
    .m-ad{
        margin-top: 0.5rem;
        padding: 0 0.3rem;
        li{
            margin-bottom: 0.3rem;
        }
        img{
            width: 100%;
            border-radius: 0.15rem;
        }
    } 
    .m-video{
        padding: 0 0.3rem;
        margin-top: 0.5rem;
        .movie{
            width: 100%;
        }
        .title{
            padding: 0.4rem 0;
            text-align: center;
            font-size: 0.35rem;
            color: #fff;
            background: #3f6648;
            margin-top: -0.1rem;
        }
    }
    .news-list-down{
        margin-top: 0.35rem;
        padding-bottom: 0.6rem;
        border-bottom: 1px solid #d8d8d8;
        ul{
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            flex-wrap: wrap;
        }
        li{
            box-sizing: border-box;
            width: 50%;
            padding: 0.2rem 0.3rem;
            img{
                width: 100%;
            }
            .title{
                margin-top: 0.1rem;
                font-size: 0.35rem;
                color: #333;
            }
        }
        .more{
            margin-top: 0.4rem;
            padding: 0 1.5rem;
            a{
                display: block;
                padding: 0.2rem 0.5rem;
                color: #fff;
                font-size: 0.4rem;
                border-radius: 0.5rem;
                background: #3f6648;
                text-align: center;
                font-weight: bold;
            }
        }
    }
    .m-localtion{
        margin-top: 0.5rem;
        padding: 0 0.3rem;
        img{
            width: 100%;
            border-radius: 0.2rem;
        }
        .phone{
            margin-top: 0.5rem;
            padding: 0 1.5rem;
            i{
                display: inline-block;
                vertical-align: middle;
                width: 0.5rem;
                height: 0.5rem;
                background: url("../../assets/images/gift/phone.png") no-repeat;
                background-size: 100%;
            }
            .box{
                padding: 0.2rem 0.5rem;
                color: #fff;
                font-size: 0.4rem;
                border-radius: 0.5rem;
                background: #d14949;
                text-align: center;
                font-weight: bold;
            }
        }
    }
    .m-footer{
        margin-top: 0.5rem;
        text-align: center;
        background: url("../../assets/images/gift/footer_bg.jpg") no-repeat;
        background-size: 100%;
        padding-bottom: 2.5rem;
        p{
            font-size: 0.35rem;
            color: #333;
            margin-bottom: 0.05rem;
        }
    }  
</style>